import * as Actions from "../action/GlobalListAction";
const initialGlobalListEnable = typeof window !== "undefined" ? Number(sessionStorage.getItem("global-list-enable") || 0) : 0;

const initialState = {
    globalListEnable: Number.isNaN(initialGlobalListEnable) ? 0 : initialGlobalListEnable,
};

const GlobalListReducer = (state = initialState, action) => {
    switch (action?.type) {
        case Actions.GLOBAL_LIST_TEMPLATES: {
            return { ...state, globalListTemplates: action.payload };
        }
        case Actions.GLOBAL_LIST_ENABLE: {
            return { ...state, globalListEnable: action.payload };
        }
        case Actions.GLOBAL_LIST: {
            return { ...state, list_data: action.payload };
        }
        case Actions.GET_GLOBAL_LIST: {
            return { ...state, globalListData: action.payload.data, globalListPagination: action.payload.pagination };
        }
        case Actions.ADD_GLOBAL_LIST: {
            const updatedData = [
                action.payload.data,
                ...state.globalListData?.slice(0, -1)
            ];
            return { ...state, globalListData: updatedData, globalListPagination: { ...state?.globalListPagination, total_count: state?.globalListPagination?.total_count + 1 } };
        }
        case Actions.EDIT_GLOBAL_LIST: {
            const current = Array.isArray(state.globalListData)
                ? state.globalListData
                : [];

            const id = action?.payload?.id;

            const updatedList = current.map(item =>
                item?.id === id
                    ? {
                        ...item,
                        ...action.payload,
                    }
                    : item
            );

            return { ...state, globalListData: updatedList };
        }
        case Actions.DELETE_GLOBAL_LIST: {
            return { ...state, delete_list_data: action.payload };
        }
        default: {
            return state;
        }
    }
};

export default GlobalListReducer;
